import { useEffect, useRef } from "react";
import { Box, styled } from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import "./ProgressBar.css";

interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
}

const ProgressStep = styled(Box)(({ theme }) => ({
  border: `2px solid rgb(229 231 235)`,
  "&.progress-step-active": {
    backgroundColor: theme.palette.primary.main,
    border: `2px solid ${theme.palette.primary.main}`,
  },
  "&.progress-step-confirmed": {
    backgroundColor: theme.palette.primary.main,
    border: `2px solid ${theme.palette.primary.main}`,
    "&.progress": {
      backgroundColor: theme.palette.primary.main,
    },
  },
})) as typeof Box;

const ProgressBar = ({ currentStep, totalSteps }: ProgressBarProps) => {
  const progressRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    updateProgress(currentStep, totalSteps);
  }, [currentStep, totalSteps]);

  const updateProgress = (currentStep: number, totalSteps: number): void => {
    const progress = progressRef.current;
    const step = currentStep + 1;
    if (progress) {
      const progressWidth = ((step - 1) / (totalSteps - 1)) * 100;
      progress.style.width = `${progressWidth}%`;
      progress.style.transition = "width 0.1s ease-in-out";
    }
  };

  return (
    <div>
      <div className="progressbar">
        <Box
          ref={progressRef}
          className="progress"
          id="progress"
          sx={{ backgroundColor: "primary.main" }}
        ></Box>
        {[...Array(totalSteps)].map((_, index) => (
          <ProgressStep
            key={index}
            className={`progress-step ${index === currentStep ? "progress-step-active" : ""} ${
              index < currentStep ? "progress-step-confirmed" : ""
            }`}
          >
            <DoneIcon
              className="done-icon confirmed-icon"
              sx={{
                color: "#fff",
                width: "20px",
                "&:hover": {
                  color: "#fff",
                },
              }}
            />
            <DoneIcon
              className="done-icon active-icon"
              sx={{
                width: "20px",
                color: "#fff",
                "&:hover": {
                  color: "#fff",
                },
              }}
            />
          </ProgressStep>
        ))}
      </div>
    </div>
  );
};

export default ProgressBar;
